export interface MangaCategory {
  id: string;
  name: string;
  icon: string;
  desc: string;
}

export const mangaCategories: MangaCategory[] = [
  {
    id: "hot-blooded",
    name: "热血冒险",
    icon: "ri-fire-line",
    desc: "燃烧斗志的热血冒险故事,主角一路成长蜕变",
  },
  {
    id: "shonen",
    name: "少年漫画",
    icon: "ri-user-star-line",
    desc: "充满梦想与羁绊的少年向作品,友情与努力的主题",
  },
  {
    id: "battle",
    name: "奇幻战斗",
    icon: "ri-sword-line",
    desc: "异能、魔法与战斗交织的奇幻世界",
  },
  {
    id: "school",
    name: "校园搞笑",
    icon: "ri-school-line",
    desc: "轻松搞笑的校园日常与青春故事",
  },
  {
    id: "completed",
    name: "完结作品",
    icon: "ri-check-double-line",
    desc: "已完结的经典作品,可以一口气畅快追完",
  },
  {
    id: "ongoing",
    name: "连载中",
    icon: "ri-loader-4-line",
    desc: "正在火热连载的人气作品,每周准时更新",
  },
];